import { useEffect, useState } from "react";
import { Button, CircularProgress, MenuItem, Select } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from 'react-query'
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { move } from "../services/api";
import { useTranslation } from "react-i18next";
import { getCategoriesByMenu } from "routes/Builder/Categories/services/api";

export default function Move({ open, close, menu, category, instanceSelected, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [optionsCategories, setOptionsCategories] = useState(null)
  const [selectInstance, setSelectInstance] = useState(null)
  const queryClient = useQueryClient()
  const { data } = useQuery(
    ['categoriesByMenu', menu], () => getCategoriesByMenu(menu),
    { refetchOnWindowFocus: false, enabled: menu !== null && menu !== undefined }
  )

  useEffect(() => {
    if (open) queryClient.invalidateQueries('categoriesByMenu')
  }, [open])

  useEffect(() => {
    if (data !== null && data !== undefined) {
      let options = []
      data.data.forEach(cat => {
        options.push({ _id: cat._id, name: cat.name })
      });
      setOptionsCategories(options)
    }
  }, [data])

  const mutation = useMutation(move, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleMove = () => {
    setIsLoading(true)
    mutation.mutate({ id: instanceSelected._id, params: { categoryOld: category, category: selectInstance }})
  }

  const handleClose = () => { close() }

  const handleChange = (event) => setSelectInstance(event.target.value)

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t('button_text_cancel')}</Button>
      <Button variant="contained" color="info" onClick={() => handleMove()}>{t('button_text_move')}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={t('builder_subcategories_dialog_title_move')} actions={<Actions />}>
      <>
        {(data !== null && optionsCategories !== null) ?
          <div>
            <Select fullWidth size="small" margin="dense" id="grouped-select" onChange={handleChange}>
              <MenuItem value={null}> <em>{t('builder_page_menu_select_label')}</em> </MenuItem>
              {optionsCategories.map((opt, j) => (
                <MenuItem key={`${opt._id}-${j}`} role="option" value={opt._id} disabled={instanceSelected.category === opt._id}> {opt.name} </MenuItem>
              ))}
            </Select>
          </div> : null}
      </>
    </FlexibleWidthDialog>
  </>)
}